import { render, staticRenderFns } from "./CulcSum.vue?vue&type=template&id=4cc6e0e6&scoped=true&"
import script from "./CulcSum.vue?vue&type=script&lang=js&"
export * from "./CulcSum.vue?vue&type=script&lang=js&"
import style0 from "./CulcSum.vue?vue&type=style&index=0&id=4cc6e0e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc6e0e6",
  null
  
)

export default component.exports